import Suspense from "components/shared/Suspense";
import LoadingBook from "hardcover-ui/components/LoadingBook";
import classNames from "lib/classNames";
import { ReactNode } from "react";

export default function PageWrapper({
  children,
  className = "",
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <Suspense fallback={<LoadingBook />}>
      <div className={classNames("min-h-screenHeightWithoutHeader", className)}>
        {children}
      </div>
    </Suspense>
  );
}
